import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { UploadFileService } from 'app/_services/upload-file.service';
import { LoadingFileDialogComponent } from '../loading-file-dialog/loading-file-dialog.component';
import { MatDialog, MatSnackBar } from '@angular/material';
import { HttpEventType } from '@angular/common/http';
import { LanguageService } from "app/_services/language.service";
import { ServiceAccountCodeModalComponent } from '../service-account-code-modal/service-account-code-modal.component';

@Component({
  selector: 'fury-indexing-images',
  templateUrl: './indexing-images.component.html',
  styleUrls: ['./indexing-images.component.scss'],
})
export class IndexingImagesComponent implements OnInit {
  public uploadedFiles: string[] = [];
  private serviceAccountValidatorsFGStorageLink = [];
  visionApiList: string[] = [];
  selected = -1;

  public formGroupFiles = this.fb.group({
    file: ['', Validators.required],
    featureTypeCodes: [null, Validators.required]
  });
  public formGroupStorageLink = this.fb.group({
    link: [null, Validators.required],
    isPrivateBucket: [false],
    serviceAccount: ['', this.serviceAccountValidatorsFGStorageLink],
    featureTypeCodes: [null, Validators.required]
  });

  @ViewChild("fileUploaderImages")
  fileUpload: ElementRef;
  files = [];
  dialogRef;
  sendLinkIsLoading: boolean = false;
  objectKeys = Object.keys;


  constructor(private fb: FormBuilder,
    private uploadFileService: UploadFileService,
    private dialog: MatDialog,
    private snackBarVideo: MatSnackBar,
    public languageService: LanguageService
  ) { }

  ngOnInit() {
    this.onValueFormChange();
    this.getFeatureTypes();
  }

  getFeatureTypes(){
    this.uploadFileService.getFeatureTypes().subscribe((res) =>{
      this.visionApiList = res.body;
    })
  }

  public onFileChange(event) {
    const formData: any = new FormData();
    let filesNames: string[] = [];
    if (event.target.files && event.target.files.length) {
      Array.from(event.target.files).forEach((file: File) => {
        formData.append('files', file);
        filesNames.push(file.name)
      });
      formData.append('featureTypeCodes', this.formGroupFiles.value.featureTypeCodes);
      this.dialogRef = this.dialog.open(LoadingFileDialogComponent, { width: '380px', disableClose: true });
      this.dialogRef.componentInstance.percentage = 0;
      this.dialogRef.componentInstance.currentFile = filesNames[0];

      this.uploadFileService.uploadImagesFiles(formData).subscribe(

        upServiceEvent => {
          switch (upServiceEvent.type) {
            case HttpEventType.UploadProgress: {
              const percentDone = Math.round(100 * upServiceEvent.loaded / upServiceEvent.total);
              this.dialogRef.componentInstance.percentage = percentDone
              let currentFilesIndex = Math.round((filesNames.length * percentDone / 100))
              this.dialogRef.componentInstance.currentFile = filesNames[currentFilesIndex];
              break;
            }
            case HttpEventType.Response: {
              if (upServiceEvent.status === 200) {
                this.showSuccessToast();
                this.formGroupFiles.reset();
              }
              this.dialog.closeAll();
              break;
            }
            default: {
              console.log(upServiceEvent);
            }
          }
        },
        err => {
          this.showErroToast('general.serviceError');
          this.dialog.closeAll();
          console.error(err)
        },
      )
    }
  }

  public onSubmitStorageLink() {
    this.sendLinkIsLoading = true;
    const formData = new FormData();
    formData.append('externalUrl', this.formGroupStorageLink.value.link.trim());
    formData.append('serviceAccount', this.formGroupStorageLink.value.serviceAccount);
    formData.append('isPrivateBucket', (this.formGroupStorageLink.value.isPrivateBucket !== null ? this.formGroupStorageLink.value.isPrivateBucket : false))
    formData.append('featureTypeCodes', this.formGroupStorageLink.value.featureTypeCodes);
    this.uploadFileService.sendImagesStorageLink(formData).subscribe(
      resp => {
        if (resp.type === HttpEventType.Response) {
          this.formGroupStorageLink.value.link = '';
          this.sendLinkIsLoading = false;
          this.formGroupStorageLink.reset();
          if (resp.status === 200) {
            this.showSuccessToast();
          } else {
            this.showErroToast('index-images.noFilesFound');
          }
        }
      },
      err => {
        this.sendLinkIsLoading = false;
        switch (err.status) {
          case 403: {
            this.showErroToast('index-images.noPublicBucket');
            break;
          }
          default: {
            this.showErroToast('general.serviceError');
          }
        }

      })
  }

  private showSuccessToast() {
    this.snackBarVideo.open(
      this.languageService.getLabel('index-file.operationStarted'),
      'OK',
      {
        duration: 15000,
        horizontalPosition: 'center'
      }
    );
  }
  private showErroToast(error) {
    this.snackBarVideo.open(
      this.languageService.getLabel(error),
      'OK',
      {
        duration: 10000,
        horizontalPosition: 'center'
      }
    );
  }
  onValueFormChange(){
    this.formGroupStorageLink.get('isPrivateBucket').valueChanges
    .subscribe(value => {
      if(value) {
        this.formGroupStorageLink.get('serviceAccount').setValidators(this.serviceAccountValidatorsFGStorageLink.concat(Validators.required))
      } else {
        this.formGroupStorageLink.get('serviceAccount').setValidators(this.serviceAccountValidatorsFGStorageLink)
      }
      this.formGroupStorageLink.get('serviceAccount').updateValueAndValidity();
      this.formGroupStorageLink.updateValueAndValidity();
    });
  }
  setIsPrivateBucket(event) {
    this.formGroupStorageLink.controls['isPrivateBucket'].setValue(event)
  }
  showServiceAccountModal(formType) {
    const _this = this
    const serviceAccountDialog = this.dialog.open(ServiceAccountCodeModalComponent, {
      width: '500px'
    });
    serviceAccountDialog.afterClosed().subscribe(
      data => {
        formType.controls.serviceAccount.setValue(data)
      }
    );
  }
   /*checkbox change event*/
   onChange(event) {
    // This is intentional
   }
}
